import Vue from 'vue'
import App from './App.vue'

Vue.config.productionTip = false

/*
Vue.config.errorHandler = (err) => {
  // , instance, info
  alert("Vue error: " + err);
}
*/

new Vue({
  render: h => h(App),
}).$mount('#app')


